import { useMemo } from 'react';
import merge from 'lodash.merge';
export var useI18n = function (i18nDefaults, i18nOverrides) {
    var i18n = useMemo(function () { return merge(i18nDefaults, i18nOverrides); }, [
        i18nDefaults,
        i18nOverrides,
    ]);
    return i18n;
};
//# sourceMappingURL=use-i18n.js.map